import { Button, Stack, Typography } from '@mui/material';
import { useFirebase } from 'contexts/FirebaseContext';
import { sendEmailVerification } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { appUrl } from 'utils/appUrl';

export function VerifyEmail() {
  const { t } = useTranslation();
  const [isVerifying, setIsVerifying] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const { auth } = useFirebase();
  const [searchParams] = useSearchParams();

  const handleResendVerification = async () => {
    setIsVerifying(true);

    try {
      const user = auth.currentUser;

      if (user) {
        await sendEmailVerification(user, { url: appUrl(`?email=${user.email}`).toString() });
        setSuccessMessage(`Verification email sent to ${user.email}`);
      }
    } catch (error) {
      // TODO: handle error " FirebaseError: Firebase: Error (auth/too-many-requests)."

      console.error('Failed to send verification email:', error);
      setErrorMessage('Failed to send verification email.');
    } finally {
      setIsVerifying(false);
    }
  };

  // const handleLogout = () => {
  //   setUser(null);
  // };

  useEffect(() => {
    searchParams.get('email');
  }, []);

  return (
    <Stack direction="column" spacing={2} sx={{ justifyContent: 'center', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        {t('verifyEmailAddress', 'Please verify your email address')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t(
          'verifyEmailAddressNotification',
          'A verification email has been sent to your email address. Please check your inbox and click\r\n        on the verification link. It may take a few minutes until the email arrives.'
        )}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleResendVerification}
        disabled={isVerifying}
      >
        {isVerifying ? 'Sending...' : t('resendVerificationEmail', 'Resend Verification Email')}
      </Button>
      {/* <Button variant="contained" color="secondary" onClick={handleLogout}>
          Logout
        </Button> */}
      {errorMessage && <Typography color="error">{errorMessage}</Typography>}
      {successMessage && <Typography color="success">{successMessage}</Typography>}
    </Stack>
  );
}
